import TermList from "../AdminTermList";

export default class AdminTermListPlaceOfService extends TermList {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return 'place_of_service';
    }
}
